var exports = {
  "qM": "AttachmentSingleMedia.module__relativeWrapper___U2RsYm",
  "u7": "AttachmentSingleMedia.module__singleMediaContainer___U2RsYm",
};

module.exports = exports;
